var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usertransactions"},[_c('v-col',[_c('v-row',[_c('v-col',[_c('UserDevices')],1)],1),_c('v-row',[_c('v-col',[_c('UserOffers')],1)],1),_c('v-row',[_c('v-col',[_c('UserDeals')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }